import { css } from '@emotion/react'
import { forwardRef, memo, ReactEventHandler } from 'react'
import { aspectRatio } from '../../../utilities/dimensions'
import { PAPER_HEIGHTS } from '../../theme'

type PosterImageProps = {
    onError?: ReactEventHandler<HTMLImageElement>
    onLoad?: ReactEventHandler<HTMLImageElement>
    setDimensions?: boolean
    testId?: string
    height: number
    width: number
    src: string
}

const PosterImage = memo(
    forwardRef<HTMLImageElement, PosterImageProps>((props, ref) => {
        const { setDimensions, width, height, src, testId, onLoad, onError } =
            props
        const { height: imageHeight, width: imageWidth } = aspectRatio({
            height,
            width,
        })
        const setHeight = setDimensions && imageHeight > 0
        const setWidth = setDimensions && imageWidth > 0
        const cssHeight = setHeight
            ? `${imageHeight}px !important`
            : '100% !important'
        const cssWidth = setWidth
            ? `${imageWidth}px !important`
            : '100% !important'
        const imageCss = css({
            height: cssHeight,
            width: cssWidth,
            ...(setHeight && setWidth
                ? { aspectRatio: `${imageWidth}/${imageHeight}` }
                : {}),
            zIndex: PAPER_HEIGHTS.base,
        })
        return (
            <img
                ref={ref}
                src={src}
                css={imageCss}
                {...(setHeight ? { height: imageHeight } : {})}
                {...(setWidth ? { width: imageWidth } : {})}
                onLoad={onLoad}
                onError={onError}
                data-testid={testId}
            />
        )
    }),
)

export default PosterImage
